<template>
	<CToast
		:key="`toast-${toast.id}`"
		:class="className"
		:show="toast.isShow"
		:header="toast.header"
		:title="toast.title"
	>
		<div>{{ toast.content }}</div>
	</CToast>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: 'ToastBox',
	props: {
		toast: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			timeout: null,
		};
	},
	computed: {
		className() {
			const type = this.toast.type || 'default';
			return `toast-${type}`;
		},
	},
	methods: {
		...mapActions({
			hideToast: 'toast/hideToast',
		}),
	},
};
</script>
